import { CHANNEL_TYPES } from "./constants";
import {
  buildCaptureEmbedSnippet,
  captureCdnScriptUrl,
  channelSlug,
} from "./feedbackService";
import { computeVoiceCaptureSetupSteps, setupProgress } from "./setupUtils";

export function getWidgetSetupState(widget, { apiReady = true } = {}) {
  const steps = computeVoiceCaptureSetupSteps(widget, { apiReady });
  return { steps, progress: setupProgress(steps) };
}

export function getWidgetEmbedSnippet(widget) {
  if (!widget) return null;
  const embedOn = (widget.channels || []).some(
    (c) => c.channel_type === CHANNEL_TYPES.WEB_EMBED && c.enabled,
  );
  const slug = channelSlug(widget, CHANNEL_TYPES.WEB_EMBED);
  if (!embedOn || !slug) return null;

  const embedCh = (widget.channels || []).find(
    (c) => c.channel_type === CHANNEL_TYPES.WEB_EMBED,
  );
  return buildCaptureEmbedSnippet(slug, {
    modes: widget.modes,
    displayMode: embedCh?.config?.display_mode || "popup",
    prompt: widget.prompt,
  });
}

export function isGlobalSetupComplete(widgets, apiReady) {
  if (!apiReady) return false;
  if (!widgets.length) return false;
  return widgets.every((w) => {
    const { progress } = getWidgetSetupState(w, { apiReady });
    return progress.done === progress.total;
  });
}

export { captureCdnScriptUrl, buildCaptureEmbedSnippet, channelSlug };
